import React from 'react';
import { motion } from 'framer-motion';
import StatusBadge from '../ui/StatusBadge';
import ThemeToggle from '../ui/ThemeToggle';

const Navbar = ({ isMenuOpen, setIsMenuOpen }) => {
  const navLinks = [
    { name: 'O mne', href: '#about' },
    { name: 'Skúsenosti', href: '#experience' },
    { name: 'Vzdelanie', href: '#education' },
    { name: 'Projekty', href: '#projects' },
    { name: 'Kontakt', href: '#footer' },
  ];

  return (
    <nav className="border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 transition-colors duration-300 sticky top-0 z-50">
      <div className="container mx-auto px-6 py-6 flex justify-between items-center">
        <div className="flex items-center gap-6">
          <h1 className="text-3xl md:text-4xl font-bold whitespace-nowrap">
            <span className="text-gray-900 dark:text-white">panenko</span>
            <span className="text-blue-600 relative underline-3d">.dev</span>
          </h1>
          <div className="hidden lg:block">
            <StatusBadge />
          </div>
        </div>
        
        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8">
          {navLinks.map((link) => (
            <a 
              key={link.name}
              href={link.href} 
              className="text-xl lg:text-2xl text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-white underline-animation whitespace-nowrap"
            >
              {link.name}
            </a>
          ))}
          <ThemeToggle />
        </div>

        {/* Mobile Actions */}
        <div className="flex md:hidden items-center gap-4">
          <ThemeToggle />
          <button 
            className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-white focus:outline-none"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle Menu"
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <motion.div 
        className="md:hidden"
        initial={false}
        animate={isMenuOpen ? 'open' : 'closed'}
      >
        <motion.div
          variants={{
            open: { 
              opacity: 1,
              height: "auto",
              transition: { duration: 0.35, ease: [0.25, 0.46, 0.45, 0.94] }
            },
            closed: { 
              opacity: 0,
              height: 0,
              transition: { duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }
            }
          }}
          className="overflow-hidden bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800"
        >
          <div className="px-6 py-6 space-y-6">
            {navLinks.map((link) => (
              <a 
                key={link.name}
                href={link.href} 
                className="block text-xl text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-white" 
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <div className="pt-4 lg:hidden">
              <StatusBadge />
            </div>
          </div>
        </motion.div>
      </motion.div>
    </nav>
  );
};

export default Navbar;
